// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';

/**
 * @class Jsw.ImageSelector
 * @extends Jsw.Component
 */
export const ImageSelector = Class.create(Component, {
    _initConfiguration($super, config) {
        $super(config);
        const list = this._getConfigParam('list', {});
        this._list = Object.isArray(list) ? $H() : $H(list);
        const captions = this._getConfigParam('captions', {});
        this._captions = Object.isArray(captions) ? $H() : $H(captions);
        this._name = this._getConfigParam('name', '');
        this._value = this._getConfigParam('value', null);

        this._currentId = `${this._id}-current`;
        this._listId = `${this._id}-list`;
    },

    _initComponentElement($super) {
        $super();

        this._updateComponentElement(
            `<div class="${this._cls}-area">` +
                `<div id="${this._currentId}" class="${this._cls}-current">` +
                    '<img/>' +
                    `<p>${this._captions.get('selectedImage').escapeHTML()}</p>` +
                '</div>' +
                `<div id="${this._listId}" class="${this._cls}-select clearfix"></div>` +
            '</div>'
        );

        this._valueElement = new Element('input', {
            id: `${this._id}-value`,
            name: this._name,
            type: 'hidden',
            value: null,
        });

        this._componentElement.insert(this._valueElement);
    },

    _addEvents() {
        this._list.each(function (pair) {
            this._addImage(pair.key, pair.value);
        }, this);

        this.set(this._value);
    },

    _addImage(value, image) {
        this._componentElement.select(`#${this._listId}`).each(function (target) {
            const element = new Element('img', {
                src: image.url,
                alt: image.title,
            });

            target.insert(element);

            element.observe('click', this._onImageClick.bindAsEventListener(this, value));
        }, this);
    },

    _onImageClick(event, value) {
        this.set(value);
    },

    /**
     * Update component value.
     * @param {String} value
     */
    set(value) {
        this._valueElement.value = value;
        const image = this._list.get(value);
        this._componentElement.select(`#${this._currentId} img`).each(function (target) {
            if (image) {
                target.src = image.url;
                target.alt = image.title;
                target.show();
            } else {
                target.hide();
            }
        }, this);
    },
});



// WEBPACK FOOTER //
// ./jsw/image-selector.js